<script setup lang="ts">
import CatalogPage from "~/components/Search/CatalogPage.vue";
</script>

<template>
  <CatalogPage />
</template>
